import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from '@mui/material';

import { PropertiesLabel } from '@/modules/common/components/PropertiesLabel';
import { NumberInput } from '@/modules/common/components/inputs';

const OpacityComponent = ({
  value,
  setValue,
  disabled,
}: {
  value: number;
  setValue: (val: number) => void;
  disabled: boolean;
}) => {
  const { t } = useTranslation(['interface']);

  return (
    <>
      <PropertiesLabel i18nkey='interface:reference.properties.opacity' labelRatio={50}>
        <NumberInput disabled={disabled} unit='%' name='Opacity' value={value} minValue={0} onChange={setValue} />
      </PropertiesLabel>
      {value < 15 && <Alert severity='info'>{t('reference.image_barely_visible')}</Alert>}
    </>
  );
};

export const Opacity = memo(OpacityComponent);
